import React, { useState, useEffect } from "react";
import http from "../../../../../services/http";
import { Divider, Modal, Typography, message, Space, Input, Select, Table } from "antd";
import { PlusOutlined, SearchOutlined } from "@ant-design/icons";
const { Text } = Typography;

export const ModalCadLotes = ({ showModal, onClose }) => {
	const [loading, setLoading] = useState();

	const [dados, setDados] = useState([]);
	const [fornecedores, setFornecedores] = useState([]);
	const [fornecedorSelected, setFornecedorSelected] = useState(null);
	const [selected, setSelected] = useState([]);
	const [search, setSearch] = useState("");

	useEffect(() => {
		listarFornecedores();
	}, [showModal === true]);

	useEffect(() => {
		if (fornecedorSelected) {
			listarPedidosPendentes(fornecedorSelected);
		}
	}, [fornecedorSelected, showModal === true]);

	// LISTAR FORNECEDORES
	const listarFornecedores = async () => {
		setLoading(true);
		const api = await http("get", `v1/fornecedores/listar_ativos`, []);
		if (api.statusCode === 200) {
			let array_fornecedores = [];
			if (api.response.data) {
				api?.response?.data?.map((f) => {
					array_fornecedores.push({ label: f.descricao, value: f.id });
				});
			}
			setFornecedores(array_fornecedores);
		} else {
			message.error(api.response.message);
		}
		setLoading(false);
	};

	// LISTAR
	const listarPedidosPendentes = async (id_fornecedor) => {
		setLoading(true);
		const api = await http("get", `v1/uniformes_pedidos/listar_pendentes/${id_fornecedor}`, []);
		if (api.statusCode === 200) {
			setSelected([]);

			setDados(api.response.data);
		} else {
			message.error(api.response.message);
		}
		setLoading(false);
	};

	// SALVAR
	const salvarLote = async () => {
		if (!fornecedorSelected || selected.length === 0) return;
		const formulario = {
			id_fornecedor: fornecedorSelected,
			pedidos: selected,
		};

		setLoading(true);
		const api = await http("post", `v1/uniformes_lotes/adicionar`, formulario);
		if (api.statusCode === 200) {
			setDados([]);
			message.success("Lote criado com sucesso!");
			onClose();
		} else {
			message.error(api.response.message);
		}
		setLoading(false);
	};

	// COLUNAS TABLE
	const columns = [
		{
			title: "Nº",
			dataIndex: "id",
			sorter: (a, b) => a.id?.toString()?.localeCompare(b.id?.toString()),
		},
		{
			title: "Solicitante",
			dataIndex: "solicitante",
			render: (_, e) => e?.colaborador ?? e?.filial,
			sorter: (a, b) => (a?.colaborador ?? a?.filial)?.localeCompare(b?.colaborador ?? b?.filial),
		},
		{
			title: "Produto",
			dataIndex: "produto",
			sorter: (a, b) => a.produto?.localeCompare(b.produto),
		},
		{
			title: "Tamanho",
			dataIndex: "tamanho",
			sorter: (a, b) => a.tamanho?.localeCompare(b.tamanho),
		},
		{
			title: "QTD.",
			dataIndex: "quantidade",
			sorter: (a, b) => a.quantidade?.toString()?.localeCompare(b.quantidade?.toString()),
		},
		{
			title: "Valor",
			dataIndex: "valor_total",
			sorter: (a, b) => a.valor_total?.toString()?.localeCompare(b.valor_total?.toString()),
		},
	];

	const onCheck = async (dados_selected, dados) => {
		setLoading(true);
		let array_dados = [];
		dados?.map((e) => {
			array_dados.push(e.id);
		});

		setSelected((array) =>
			array.filter(function (x) {
				return array_dados.indexOf(x) < 0;
			})
		);
		setSelected((val) => [...val, ...dados_selected]);
		setLoading(false);
	};

	// ON FILTER
	const handleFilter = (pesquisar) => {
		let filteredData = dados?.filter(
			(val) =>
				val.colaborador?.toLowerCase().includes(pesquisar.toLowerCase()) ||
				val.filial?.toLowerCase().includes(pesquisar.toLowerCase()) ||
				val.id?.toString()?.toLowerCase().includes(pesquisar.toLowerCase()) ||
				val.tamanho?.toLowerCase().includes(pesquisar.toLowerCase()) ||
				val.valor_total?.toLowerCase().includes(pesquisar.toLowerCase()) ||
				val.status_desc?.toLowerCase().includes(pesquisar.toLowerCase()) ||
				val.produto?.toLowerCase().includes(pesquisar.toLowerCase())
		);

		return filteredData;
	};

	const dadosFilter = dados?.length > 0 ? handleFilter(search) : [];

	// CHECK ROW
	const rowSelection = {
		type: "checkbox",
		disabled: true,
		selectedRowKeys: selected,
		onSelectAll: (e) => {
			if (loading) return;
			let array = [];
			if (e === true) array = dadosFilter.map((e) => e.id);

			onCheck(array, dadosFilter);
		},
		onSelect: (data, status) => {
			if (loading) return;
			onCheck(status ? [data.id] : [], [{ id: data.id }]);
		},
	};

	return (
		<Modal
			title={
				<Text style={{ fontSize: 20 }}>
					<PlusOutlined /> Novo Lote
				</Text>
			}
			open={showModal}
			width={1200}
			cancelText="Cancelar"
			okText="Salvar"
			cancelButtonProps={{ loading: loading, size: "large" }}
			okButtonProps={{
				loading: loading,
				size: "large",
				disabled: selected.length === 0,
			}}
			onOk={salvarLote}
			onCancel={onClose}>
			<Space wrap>
				<Input
					size="middle"
					maxLength={100}
					prefix={<SearchOutlined />}
					className="input"
					value={search}
					onChange={(e) => setSearch(e.target.value)}
					placeholder="Pesquisar..."
					allowClear
				/>
				<Select
					placeholder="Selecione um fornecedor"
					style={{ minWidth: 180 }}
					value={fornecedorSelected}
					onChange={(e) => setFornecedorSelected(e)}
					options={fornecedores}
				/>
			</Space>
			<Divider />
			<Table
				rowKey="id"
				scroll={{ x: 700 }}
				loading={loading}
				columns={columns}
				dataSource={dadosFilter}
				size="small"
				rowSelection={rowSelection}
			/>
		</Modal>
	);
};
